import { ECookies } from '@olo-web/types/enums';

/**
 * The preferred-location cookie is namespaced per merchant group so each brand
 * remembers its own last-selected location independently (and a site-wide cookie
 * path can be used without brands clobbering one another). Falls back to the base
 * name when no group id is available.
 */
export function getPreferredLocationCookieName(groupId?: number | string): string {
  return groupId ? `${ECookies.preferredLocation}_${groupId}` : ECookies.preferredLocation;
}
